/**
 * Application version - single source of truth
 * Update this when releasing new versions
 */
export const APP_VERSION = '1.0.0';
